var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list_container"},[_c('h5',{staticClass:"text-center m1"},[_c('strong',[_vm._v("Bestanden")])]),_c('hr',{staticClass:"m-1"}),_c('a',{staticClass:"clickable_file",attrs:{"target":"_blank","href":"https://kleyn.sharepoint.com"}},[_c('div',{staticClass:"intranet_file"},[_vm._v(" De bestanden staan op Ask Katy! ")])])])
}]

export { render, staticRenderFns }